import { AuthService } from '../../auth/auth.service';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { Component, Input } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CLOSE_SESSION } from 'src/app/util/constantes-mensajes';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  faCaretDown = faCaretDown;
  @Input() title: string = "";
  @Input() isMobile: boolean = false;
  disabledLink = null;

  constructor(private authService: AuthService, private modalService: ModalService) { }

  logout() {
    this.modalService.getConfirmacionModal({ message: CLOSE_SESSION, confirmTitle: "Aceptar" })
      .result.then((result) => {
        if (result)
          this.authService.logout();
      })
  }
}
